export default class Faq {
  constructor() {
    this.root = null;
    this.nav = null;
    this.links = [];
    this.sections = [];
    this.linkHandlers = [];
    this.bindOnScroll = this.onScroll.bind(this);
    this.cacheElements();
  }

  start() {
    if (!this.root || !this.nav || !this.links.length) return;

    this.bindEvents();
    this.onScroll();
  }

  reset() {
    this.destruct();
    this.cacheElements();
    this.start();
  }

  destruct() {
    this.linkHandlers.forEach(({ link, handler }) => {
      link.removeEventListener("click", handler);
    });
    this.linkHandlers = [];

    window.removeEventListener("scroll", this.bindOnScroll);
    window.removeEventListener("resize", this.bindOnScroll);
  }

  cacheElements() {
    this.root = document.querySelector("main.faq");
    if (!this.root) return;

    this.nav = this.root.querySelector(".js-faq-nav");
    if (!this.nav) return;

    this.links = Array.from(
      this.nav.querySelectorAll(".js-faq-nav-link, a[href^='#faq-cat-']")
    );

    this.sections = this.links
      .map((link) => {
        const href = link.getAttribute("href") || "";
        const id = href.startsWith("#") ? href.slice(1) : "";
        if (!id) return null;

        const section = document.getElementById(id);
        return section ? { id, section } : null;
      })
      .filter(Boolean);
  }

  bindEvents() {
    this.links.forEach((link) => {
      const handler = (event) => {
        const href = link.getAttribute("href") || "";
        if (!href.startsWith("#")) return;

        const targetId = href.slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - this.getScrollOffset();
        window.scrollTo({ top, behavior: "smooth" });
      };

      link.addEventListener("click", handler);
      this.linkHandlers.push({ link, handler });
    });

    window.addEventListener("scroll", this.bindOnScroll, { passive: true });
    window.addEventListener("resize", this.bindOnScroll);
  }

  getScrollOffset() {
    const header = document.querySelector("header");
    if (header) {
      return Math.round(header.getBoundingClientRect().height + 24);
    }

    return window.innerWidth <= 1023 ? 88 : 120;
  }

  onScroll() {
    if (!this.sections.length) return;

    const threshold = this.getScrollOffset() + 20;
    let currentId = this.sections[0].id;

    this.sections.forEach(({ id, section }) => {
      if (section.getBoundingClientRect().top <= threshold) {
        currentId = id;
      }
    });

    this.links.forEach((link) => {
      const href = link.getAttribute("href") || "";
      const id = href.startsWith("#") ? href.slice(1) : "";
      const isCurrent = id === currentId;

      link.classList.toggle("is-current", isCurrent);
      if (isCurrent) {
        link.setAttribute("aria-current", "true");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }
}
